import React from 'react';
import * as Recharts from 'recharts';
import { Icon } from './icons.jsx';
import { KB_ARTICLES, REPORTS_BY_STATUS, REPORTS_TICKETS_DATA, REPORTS_TOP_TENANTS, SUPPORT_AGENTS } from './support-data.jsx';
// Suporte — Relatórios de Suporte (menu próprio)

const SupportReportsPage = ({ onToast }) => {
  const [tab, setTab]       = React.useState('overview');
  const [period, setPeriod] = React.useState('30d');
  const [planFilter, setPlanFilter] = React.useState('');

  const { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell,
          XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } = Recharts;

  const ticketData   = REPORTS_TICKETS_DATA || [];
  const statusData   = REPORTS_BY_STATUS    || [];
  const tenantData   = REPORTS_TOP_TENANTS  || [];

  const agents = SUPPORT_AGENTS || [];

  const agentStats = [
    { name:'Ana Vargas',      tickets:32, resolved:28, avgReply:'1h 12min', sla:96, csat:4.7 },
    { name:'Pedro Chaves',    tickets:28, resolved:25, avgReply:'0h 58min', sla:98, csat:4.8 },
    { name:'Beatriz Lima',    tickets:18, resolved:17, avgReply:'1h 34min', sla:92, csat:4.5 },
    { name:'Rafael Tavares',  tickets:12, resolved:12, avgReply:'2h 10min', sla:100, csat:4.9 },
  ];

  const kpiData = [
    { label:'Tickets criados',          value: 96,        icon:'plus',         delta:'+12%',   up:true   },
    { label:'Tickets resolvidos',       value: 82,        icon:'check',        delta:'+8%',    up:true   },
    { label:'1ª resposta média',        value: '1h 48min',icon:'activity',     small:true                },
    { label:'Resolução média',          value: '8h 22min',icon:'clock',        small:true                },
    { label:'CSAT',                     value: '4.7 / 5', icon:'star',         small:true, ok:true       },
    { label:'Cumprimento de SLA',       value: '91%',     icon:'shield',       ok:true, small:true       },
    { label:'Resolvidos por artigo',    value: '34%',     icon:'bookOpen',     ok:true, small:true       },
    { label:'Tickets por tenant/mês',   value: '19,2',    icon:'store',        small:true                },
  ];

  const catBreakdown = [
    { name:'Domínio',           value:24, color:'#1d4ed8' },
    { name:'Pagamento',         value:18, color:'#059669' },
    { name:'Integrações',       value:16, color:'#7c3aed' },
    { name:'E-mail',            value:12, color:'#b45309' },
    { name:'Billing',           value:11, color:'#dc2626' },
    { name:'Frete',             value:9,  color:'#0891b2' },
    { name:'Catálogo',          value:6,  color:'#4f46e5' },
  ];

  const TABS = [
    { id:'overview',  label:'Visão geral',         icon:'dashboard'     },
    { id:'sla',       label:'SLA',                 icon:'clock'         },
    { id:'team',      label:'Performance do time', icon:'users'         },
    { id:'tenants',   label:'Tenants',             icon:'store'         },
    { id:'kb',        label:'Base de Conhecimento',icon:'bookOpen'      },
  ];

  const SectionTitle = ({ title, sub }) => (
    <div style={{ marginBottom:14 }}>
      <div style={{ fontWeight:600,fontSize:14 }}>{title}</div>
      {sub && <div style={{ fontSize:12,color:'var(--text-muted)' }}>{sub}</div>}
    </div>
  );

  return (
    <div className="content wide" style={{ maxWidth:1300 }}>

      {/* Header */}
      <div className="page-header">
        <div>
          <h1>Relatórios de Suporte</h1>
          <p className="sub">Métricas de atendimento, SLA, tenants e base de conhecimento.</p>
          <div style={{ fontSize:11,fontFamily:'JetBrains Mono,monospace',color:'var(--text-muted)',opacity:.6,marginTop:3 }}>/admin/support/reports</div>
        </div>
        <div className="actions">
          <button className="btn" onClick={()=>onToast&&onToast('Exportando relatório…')}><Icon name="download" size={14}/>Exportar CSV</button>
        </div>
      </div>

      {/* Filtros globais */}
      <div style={{ display:'flex',gap:10,marginBottom:20,flexWrap:'wrap',alignItems:'center' }}>
        <select className="select" value={period} onChange={e=>setPeriod(e.target.value)}>
          <option value="7d">Últimos 7 dias</option>
          <option value="30d">Últimos 30 dias</option>
          <option value="90d">Últimos 90 dias</option>
          <option value="ytd">Ano atual</option>
        </select>
        <select className="select" value={planFilter} onChange={e=>setPlanFilter(e.target.value)}>
          <option value="">Todos os planos</option>
          <option value="Basic">Basic</option>
          <option value="Pro">Pro</option>
          <option value="Enterprise">Enterprise</option>
        </select>
        <select className="select"><option value="">Todos os agentes</option>{agents.map(a=><option key={a.id}>{a.name}</option>)}</select>
        <select className="select"><option value="">Todas as categorias</option>{['Domínio','Pagamento','Integrações','E-mail','Billing'].map(c=><option key={c}>{c}</option>)}</select>
        <div style={{ marginLeft:'auto',fontSize:12,color:'var(--text-muted)',display:'flex',alignItems:'center',gap:4 }}>
          <Icon name="refresh" size={13}/>Atualizado há 5min
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20 }}>
        {kpiData.slice(0,8).map(k=>(
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
            <div className="value" style={{ fontSize:k.small?20:28,color:k.ok?'var(--success)':undefined }}>{k.value}</div>
            {k.delta && <div className={`delta ${k.up?'up':'down'}`}><Icon name={k.up?'arrowUp':'arrowDown'} size={11}/>{k.delta} vs período anterior</div>}
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex',borderBottom:'1px solid var(--border)',marginBottom:24,overflowX:'auto' }}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            display:'flex',alignItems:'center',gap:6,padding:'9px 16px',border:'none',background:'transparent',
            fontSize:13,fontWeight:tab===t.id?600:500,color:tab===t.id?'var(--text)':'var(--text-muted)',
            borderBottom:tab===t.id?'2px solid var(--brand-navy)':'2px solid transparent',
            marginBottom:-1,cursor:'pointer',whiteSpace:'nowrap',transition:'color 120ms',
          }}>
            <Icon name={t.icon} size={13}/>{t.label}
          </button>
        ))}
      </div>

      {/* ── Tab: Visão geral ── */}
      {tab==='overview' && (
        <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
          <div style={{ display:'grid',gridTemplateColumns:'2fr 1fr',gap:20 }}>
            {/* Volume ao longo do tempo */}
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>Volume de tickets por dia</h3></div>
              <div style={{ padding:'16px 12px' }}>
                <ResponsiveContainer width="100%" height={220}>
                  <LineChart data={ticketData} margin={{ top:5,right:20,left:-10,bottom:5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--border)"/>
                    <XAxis dataKey="dia" tick={{ fontSize:11,fill:'var(--text-muted)' }}/>
                    <YAxis tick={{ fontSize:11,fill:'var(--text-muted)' }}/>
                    <Tooltip contentStyle={{ background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:8,fontSize:12 }}/>
                    <Legend wrapperStyle={{ fontSize:12 }}/>
                    <Line type="monotone" dataKey="criados"   stroke="var(--brand-navy)" strokeWidth={2} dot={false} name="Criados"/>
                    <Line type="monotone" dataKey="resolvidos" stroke="var(--success)"   strokeWidth={2} dot={false} name="Resolvidos"/>
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Por status */}
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>Tickets por status</h3></div>
              <div style={{ padding:'16px 12px' }}>
                <ResponsiveContainer width="100%" height={160}>
                  <PieChart>
                    <Pie data={statusData} cx="50%" cy="50%" innerRadius={46} outerRadius={68} paddingAngle={3} dataKey="value">
                      {statusData.map((entry,i)=><Cell key={i} fill={entry.color}/>)}
                    </Pie>
                    <Tooltip formatter={(v,n)=>[v,'Tickets']} contentStyle={{ background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:8,fontSize:12 }}/>
                  </PieChart>
                </ResponsiveContainer>
                <div style={{ display:'flex',flexDirection:'column',gap:4,marginTop:4 }}>
                  {statusData.map(s=>(
                    <div key={s.name} style={{ display:'flex',alignItems:'center',justifyContent:'space-between',fontSize:12 }}>
                      <div style={{ display:'flex',alignItems:'center',gap:7 }}>
                        <div style={{ width:8,height:8,borderRadius:2,background:s.color,flexShrink:0 }}/>
                        <span style={{ color:'var(--text-secondary)' }}>{s.name}</span>
                      </div>
                      <span style={{ fontWeight:600 }}>{s.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:20 }}>
            {/* Por categoria */}
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>Categorias mais recorrentes</h3></div>
              <div style={{ padding:'16px 12px' }}>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart data={catBreakdown} layout="vertical" margin={{ top:0,right:20,left:60,bottom:0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" horizontal={false}/>
                    <XAxis type="number" tick={{ fontSize:11,fill:'var(--text-muted)' }}/>
                    <YAxis dataKey="name" type="category" tick={{ fontSize:11,fill:'var(--text-secondary)' }} width={60}/>
                    <Tooltip contentStyle={{ background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:8,fontSize:12 }}/>
                    <Bar dataKey="value" name="Tickets" radius={[0,4,4,0]}>
                      {catBreakdown.map((entry,i)=><Cell key={i} fill={entry.color}/>)}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Top tenants */}
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>Top tenants por volume</h3></div>
              <table className="data">
                <thead><tr><th>Tenant</th><th>Plano</th><th>Abertos</th><th>Resolvidos</th><th>SLA</th></tr></thead>
                <tbody>
                  {tenantData.map(t=>(
                    <tr key={t.tenant}>
                      <td style={{ fontWeight:500,fontSize:13 }}>{t.tenant}</td>
                      <td><span className="badge neutral" style={{ fontSize:10 }}>{t.plan}</span></td>
                      <td style={{ fontSize:13,fontWeight:600,color:t.open>3?'var(--warning)':'var(--text)' }}>{t.open}</td>
                      <td style={{ fontSize:13,color:'var(--success)',fontWeight:600 }}>{t.resolved}</td>
                      <td>{t.slaBreaches>0 ? <span className="badge danger" style={{ fontSize:10 }}><span className="dot"/>{t.slaBreaches} falhas</span> : <span className="badge success" style={{ fontSize:10 }}><span className="dot"/>Ok</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ── Tab: SLA ── */}
      {tab==='sla' && (
        <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12 }}>
            {[
              { label:'Cumprimento geral',   value:'91%',   icon:'shield',   ok:true  },
              { label:'SLA vencidos (mês)',   value:7,       icon:'alert',    danger:true },
              { label:'SLA vencido hoje',     value:2,       icon:'clock',    danger:true },
              { label:'Resposta média (N1)',  value:'1h 12min',icon:'activity',small:true },
            ].map(k=>(
              <div key={k.label} className="kpi">
                <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
                <div className="value" style={{ fontSize:k.small?20:28,color:k.danger?'var(--danger)':k.ok?'var(--success)':undefined }}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:20 }}>
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>Cumprimento de SLA por plano</h3></div>
              <div style={{ padding:'16px 18px',display:'flex',flexDirection:'column',gap:14 }}>
                {[
                  { plan:'Enterprise', pct:98, color:'var(--success)' },
                  { plan:'Pro',        pct:94, color:'var(--success)' },
                  { plan:'Basic',      pct:82, color:'var(--warning)' },
                ].map(p=>(
                  <div key={p.plan}>
                    <div style={{ display:'flex',justifyContent:'space-between',fontSize:13,marginBottom:6 }}>
                      <span style={{ fontWeight:500 }}>{p.plan}</span>
                      <span style={{ fontWeight:700,color:p.color }}>{p.pct}%</span>
                    </div>
                    <div style={{ height:8,borderRadius:4,background:'var(--bg-subtle)',overflow:'hidden' }}>
                      <div style={{ height:'100%',width:`${p.pct}%`,background:p.color,borderRadius:4,transition:'width 0.6s ease' }}/>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="card" style={{ overflow:'hidden' }}>
              <div className="card-head"><h3>SLA por prioridade</h3></div>
              <div style={{ padding:'16px 12px' }}>
                <ResponsiveContainer width="100%" height={180}>
                  <BarChart data={[
                    { priority:'Urgente', pct:88 },
                    { priority:'Alta',    pct:91 },
                    { priority:'Média',   pct:95 },
                    { priority:'Baixa',   pct:99 },
                  ]}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--border)"/>
                    <XAxis dataKey="priority" tick={{ fontSize:11,fill:'var(--text-muted)' }}/>
                    <YAxis domain={[70,100]} tick={{ fontSize:11,fill:'var(--text-muted)' }}/>
                    <Tooltip contentStyle={{ background:'var(--bg-elevated)',border:'1px solid var(--border)',borderRadius:8,fontSize:12 }} formatter={(v)=>[`${v}%`,'Cumprimento']}/>
                    <Bar dataKey="pct" name="Cumprimento %" fill="var(--brand-navy)" radius={[4,4,0,0]}/>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Tab: Performance do time ── */}
      {tab==='team' && (
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div className="table-wrap">
            <div className="table-toolbar">
              <SectionTitle title="Performance por agente" sub="Período selecionado"/>
            </div>
            <table className="data">
              <thead>
                <tr><th>Agente</th><th>Nível</th><th>Tickets</th><th>Resolvidos</th><th>1ª resposta avg</th><th>SLA cumprido</th><th>CSAT</th></tr>
              </thead>
              <tbody>
                {agentStats.map((a,i)=>{
                  const ag = (SUPPORT_AGENTS||[]).find(x=>x.name===a.name);
                  return (
                    <tr key={a.name}>
                      <td>
                        <div style={{ display:'flex',alignItems:'center',gap:9 }}>
                          <div style={{ width:30,height:30,borderRadius:'50%',background:ag?.color||'var(--brand-navy)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,color:'white',flexShrink:0 }}>
                            {a.name.split(' ').map(w=>w[0]).join('')}
                          </div>
                          <span style={{ fontWeight:500,fontSize:13 }}>{a.name}</span>
                        </div>
                      </td>
                      <td><span className="badge neutral" style={{ fontSize:10 }}>{ag?.role||'Suporte'}</span></td>
                      <td style={{ fontSize:13,fontWeight:600 }}>{a.tickets}</td>
                      <td>
                        <div style={{ display:'flex',alignItems:'center',gap:6 }}>
                          <span style={{ fontSize:13,fontWeight:600,color:'var(--success)' }}>{a.resolved}</span>
                          <div style={{ width:36,height:4,borderRadius:2,background:'var(--bg-subtle)',overflow:'hidden' }}>
                            <div style={{ height:'100%',width:`${a.resolved/a.tickets*100}%`,background:'var(--success)',borderRadius:2 }}/>
                          </div>
                          <span style={{ fontSize:11,color:'var(--text-muted)' }}>{Math.round(a.resolved/a.tickets*100)}%</span>
                        </div>
                      </td>
                      <td style={{ fontSize:12 }}>{a.avgReply}</td>
                      <td>
                        <div style={{ display:'flex',alignItems:'center',gap:6 }}>
                          <span style={{ fontSize:13,fontWeight:600,color:a.sla>=95?'var(--success)':a.sla>=85?'var(--warning)':'var(--danger)' }}>{a.sla}%</span>
                        </div>
                      </td>
                      <td>
                        <div style={{ display:'flex',alignItems:'center',gap:4 }}>
                          <Icon name="star" size={12} style={{ color:'#f59e0b' }}/>
                          <span style={{ fontWeight:600,fontSize:13 }}>{a.csat}</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Tab: Tenants ── */}
      {tab==='tenants' && (
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div className="table-wrap">
            <div className="table-toolbar">
              <SectionTitle title="Ranking de tenants por volume de suporte"/>
              <div style={{ marginLeft:'auto' }}>
                <button className="btn sm" onClick={()=>onToast&&onToast('Exportando…')}><Icon name="download" size={13}/>Exportar</button>
              </div>
            </div>
            <table className="data">
              <thead>
                <tr><th>#</th><th>Tenant</th><th>Plano</th><th>Tickets abertos</th><th>Resolvidos</th><th>SLA vencido</th><th>Categoria principal</th></tr>
              </thead>
              <tbody>
                {tenantData.map((t,i)=>(
                  <tr key={t.tenant}>
                    <td style={{ color:'var(--text-muted)',fontSize:12 }}>{i+1}</td>
                    <td style={{ fontWeight:500,fontSize:13 }}>{t.tenant}</td>
                    <td><span className="badge neutral" style={{ fontSize:10 }}>{t.plan}</span></td>
                    <td style={{ fontSize:13,fontWeight:600,color:t.open>3?'var(--warning)':'var(--text)' }}>{t.open}</td>
                    <td style={{ fontSize:13,color:'var(--success)',fontWeight:600 }}>{t.resolved}</td>
                    <td>{t.slaBreaches>0 ? <span className="badge danger" style={{ fontSize:10 }}><span className="dot"/>{t.slaBreaches}</span> : <span style={{ fontSize:12,color:'var(--text-muted)' }}>—</span>}</td>
                    <td><span className="badge info" style={{ fontSize:10 }}>{t.topCategory}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── Tab: Base de Conhecimento ── */}
      {tab==='kb' && (
        <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
          <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12 }}>
            {[
              { label:'Artigos publicados',   value: (KB_ARTICLES||[]).filter(a=>a.status==='publicado').length, icon:'fileText', ok:true },
              { label:'Total de views',        value:'9.350',  icon:'activity',    small:true },
              { label:'Tickets evitados',      value: (KB_ARTICLES||[]).reduce((s,a)=>s+a.ticketsAvoided,0), icon:'check', ok:true },
              { label:'Buscas s/ resultado',   value:47,       icon:'search',      warn:true  },
            ].map(k=>(
              <div key={k.label} className="kpi">
                <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
                <div className="value" style={{ fontSize:k.small?20:26,color:k.ok?'var(--success)':k.warn?'var(--warning)':undefined }}>{k.value}</div>
              </div>
            ))}
          </div>
          <div className="table-wrap">
            <div className="table-toolbar"><SectionTitle title="Artigos que mais reduziram tickets"/></div>
            <table className="data">
              <thead><tr><th>Artigo</th><th>Categoria</th><th>Views</th><th>Tickets evitados</th><th>Feedback</th></tr></thead>
              <tbody>
                {[...(KB_ARTICLES||[])].filter(a=>a.status==='publicado').sort((a,b)=>b.ticketsAvoided-a.ticketsAvoided).map(a=>{
                  const total = a.feedback.pos+a.feedback.neg;
                  const pct = total>0?Math.round(a.feedback.pos/total*100):0;
                  return (
                    <tr key={a.id}>
                      <td style={{ fontWeight:500,fontSize:13 }}>{a.title}</td>
                      <td><span className="badge neutral" style={{ fontSize:10 }}>{a.category}</span></td>
                      <td style={{ fontSize:13 }}>{a.views.toLocaleString('pt-BR')}</td>
                      <td><span style={{ fontWeight:700,fontSize:13,color:'var(--success)' }}>{a.ticketsAvoided}</span></td>
                      <td>
                        <div style={{ display:'flex',alignItems:'center',gap:6 }}>
                          <div style={{ width:40,height:4,borderRadius:2,background:'var(--bg-subtle)',overflow:'hidden' }}>
                            <div style={{ height:'100%',width:`${pct}%`,background:pct>=70?'var(--success)':'var(--warning)',borderRadius:2 }}/>
                          </div>
                          <span style={{ fontSize:11,fontWeight:600 }}>{pct}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export {
  SupportReportsPage,
};
